import axios from "axios";
import {baseHostV1} from "../../config";

export default {
    list: async () => {
        const response = await axios.get(`${baseHostV1}/education/list`, {params: {webActive: true}}).then(res => res.data);
        return response;
    }
}